module.exports = __webpack_public_path__ + "img/image2.9326ec9e.png";